import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';

@Component({
  selector: 'app-venta-rapida-product-step',
  templateUrl: './venta-rapida-product-step.component.html',
  styleUrls: ['./venta-rapida-product-step.component.scss'],
  standalone: false
})
export class VentaRapidaProductStepComponent {
  @Input({ required: true }) products!: Product[];
  @Output() productSelected = new EventEmitter<Product>();

  onSelect(product: Product): void {
    this.productSelected.emit(product);
  }
}
